@if (
  regionsViewModel &&
  sourcesViewModel &&
  basecasesViewModel &&
  subtypesViewModel &&
  weatherYearsViewModel
) {
  <div class="fullheight">
    @if (
      regionsViewModel.regions.length > 0 &&
      !regionsViewModel.isFetching &&
      sourcesViewModel.sources.length > 0 &&
      !sourcesViewModel.isFetching &&
      basecasesViewModel.basecases.length > 0 &&
      !basecasesViewModel.isFetching &&
      subtypesViewModel.subtypes.length > 0 &&
      !subtypesViewModel.isFetching &&
      weatherYearsViewModel.weatherYears.length > 0 &&
      !weatherYearsViewModel.isFetching
    ) {
      <div class="fullheight">
        <app-search-scenarios-form
          [regions]="regionsViewModel.regions"
          [sources]="sourcesViewModel.sources"
          [basecases]="basecasesViewModel.basecases"
          [subtypes]="subtypesViewModel.subtypes"
          [weatherYears]="weatherYearsViewModel.weatherYears"
          [marketAreas]="marketAreasViewModel?.marketAreas ?? []"
        ></app-search-scenarios-form>
      </div>
    }

    @if (
      regionsViewModel.isFetching ||
      sourcesViewModel.isFetching ||
      basecasesViewModel.isFetching ||
      subtypesViewModel.isFetching ||
      weatherYearsViewModel.isFetching
    ) {
      <div data-testid="spinner" class="center">Loading...</div>
    }

    @if (
      regionsViewModel.error ||
      sourcesViewModel.error ||
      basecasesViewModel.error ||
      subtypesViewModel.error ||
      weatherYearsViewModel.error
    ) {
      <div data-testid="search-scenarios-form-error" class="center">
        {{ regionsViewModel.error }}{{ sourcesViewModel.error }}{{ basecasesViewModel.error
        }}{{ subtypesViewModel.error }}{{ weatherYearsViewModel.error }}
      </div>
    }
  </div>
}
